import { useQuery } from '@tanstack/react-query';
import { reportsApi } from '../services/api';

export const useConsumerTransactions = (consumerCode, filters = {}) => {
  return useQuery({
    queryKey: ['consumerTransactions', consumerCode, filters.transactionType, filters.dataSource, filters.showAdmin],
    queryFn: () =>
      reportsApi.getConsumerTransactions({
        consumerCode,
        transactionType: filters.transactionType,
        dataSource: filters.dataSource,
        showAdmin: filters.showAdmin,
      }),
    enabled: !!consumerCode,
    staleTime: 2 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};

export const useConsumerTransactionSummary = (consumerCode, filters = {}) => {
  return useQuery({
    queryKey: ['consumerTransactionSummary', consumerCode, filters.transactionType, filters.dataSource, filters.showAdmin],
    queryFn: () => reportsApi.getConsumerTransactionSummary({
      consumerCode,
      transactionType: filters.transactionType,
      dataSource: filters.dataSource,
      showAdmin: filters.showAdmin,
    }),
    enabled: !!consumerCode,
    staleTime: 2 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};

export const useConsumerTransactionItemDetails = (consumerCode, transactionId, enabled = false) => {
  return useQuery({
    queryKey: ['consumerTransactionItemDetails', consumerCode, transactionId],
    queryFn: () => reportsApi.getConsumerTransactionItemDetails({ consumerCode, transactionId }),
    enabled: !!consumerCode && !!transactionId && enabled,
    staleTime: 2 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};
